module.exports = __webpack_public_path__ + "static/img/barra_2.b6857cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_2.png
// module id = 9Yxt
// module chunks = 0